import { withInstall } from '@element-plus/utils/with-install'

import Empty from './src/empty.vue'

export const ElEmpty = withInstall(Empty)
export default ElEmpty

export * from './src/empty'
